// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Box, Button, Heading } from 'grommet/es6';
import { GrommetForm } from 'speed-js-react-web';
import { WorkflowContext } from 'esm-web-pro/components/workflows';
import connectWorkflow from 'esm-web-pro/components/workflows/connectWorkflow';
// import type { Form } from 'esm-web-pro/redux/workflow/form';
import { getForm } from 'esm-web-pro/redux/workflow/form';


type Props = {
    buttonLabel: ?(string | React.Node),
    title: ?string,
    requestKey: ?string,
    executionId: string,
    initialData: ?Object,
    workflowCode: string;
    resumeFlow: Function,
    schema: ?Object,
};


const mapStateToProps = (state, props: {
    workflowCode: string;
    executionId: string,
}) => getForm(state, props.workflowCode, props.executionId) || {};


@connectWorkflow
@connect(mapStateToProps)
class WorkflowForm extends React.Component<Props> {
    static contextType = WorkflowContext;

    registeredHandler = false;

    static defaultProps = {
        resumeFlow: () => undefined,
        buttonLabel: <FormattedMessage
            id="mistral-workflowform-btn-continue"
            defaultMessage="Continue"
        />,
        requestKey: null,
        schema: null,
        title: null,
        initialData: null,
    };

    componentDidUpdate(prevProps: Props) {
        const { executionId, workflowCode, requestKey } = this.props;

        if (
            prevProps.workflowCode !== workflowCode
            || prevProps.executionId !== executionId
            || prevProps.requestKey !== requestKey
        ) {
            const { workflowManager } = this.context;
            workflowManager.removeActionHandler(executionId, 'set_validation_errors');
            this.registeredHandler = false;
        }
    }

    componentWillUnmount() {
        if (this.registeredHandler) {
            const { executionId } = this.props;
            const { workflowManager } = this.context;
            workflowManager.removeActionHandler(executionId, 'set_validation_errors');
            this.registeredHandler = false;
        }
    }

    handleSubmit = (values: Object, formik: Object) => {
        const { resumeFlow, executionId, requestKey } = this.props;

        if (!this.registeredHandler) {
            const { workflowManager } = this.context;

            workflowManager.addActionHandler(
                executionId, 'set_validation_errors',
                (data: { executionId: string, errors: Object }) => {
                    formik.setSubmitting(false);
                    formik.setErrors(data.errors);
                }, true,
            );

            this.registeredHandler = true;
        }

        resumeFlow(executionId, requestKey ? { [requestKey]: values } : values).then(() => {
            formik.setSubmitting(false);
        });
    };

    renderActions = ({ isSubmitting }: { isSubmitting: boolean }) => {
        const { buttonLabel } = this.props;

        return (
            <Box dirextion="row" margin={{ vertical: 'small', bottom: '20px' }}>
                <Button
                    label={buttonLabel}
                    type="submit"
                    alignSelf="end"
                    disabled={isSubmitting}
                    margin={{ bottom: '10px' }}
                    style={{ width: 'calc(50% - 10px)' }}
                />
            </Box>
        );
    };

    render() {
        const {
            schema, title, requestKey, initialData,
        } = this.props;

        if (!schema) return null;

        return (
            <React.Fragment>
                {title && (
                    <Heading level="3">{title}</Heading>
                )}
                <GrommetForm
                    schema={schema}
                    onSubmit={this.handleSubmit}
                    actions={this.renderActions}
                    initial={initialData}
                    // Re-mount the form when the request key changes, otherwise the data of the previous
                    // form will along be submitted along with the new one
                    key={requestKey}
                />
            </React.Fragment>
        );
    }
}

export default WorkflowForm;
